import React from "react";
import {Navigate, useNavigate} from "react-router-dom";
import {makeStyles} from "@material-ui/core/styles";
import {WithOrganization} from "../components/organizations/organization-context";
import ReactsCard from "../components/ui/ReactsCard";
import {useTranslation} from 'react-i18next';
import {useQuery} from "../utils/function-util";
import {StyleExternalProviderInviteEditor} from "../components/pro-guest/external-providers/ExternalProviderInviteEditor";

const useStyles = makeStyles(theme => ({
    root: {
        margin: theme.spacing(4),
        '& > *': {
            'margin-bottom': theme.spacing(4)
        }
    },
    top: {
        display: 'flex',
        flexDirection: 'row',
        flexGrow: 1,
        alignItems: 'center'
    }
}));

export const ExternalProsAdd: React.FC<WithOrganization> = ({currentOrganization}) => {
    const classes = useStyles();
    const navigate = useNavigate();
    const query = useQuery();
    const title = 'ProGuest.AddProviders.Title';
    const folderId = query.get('folderId');
    const {t} = useTranslation();

    if (!folderId) {
        return <Navigate to='/pro-guests' replace={false}/>;
    }

    const goBack = () => {
        navigate(`/pro-guests?folderId=${folderId}`);
    };

    return (
        <div className={classes.root}>
            <ReactsCard title={t(title)}>
                <StyleExternalProviderInviteEditor
                    organizationId={currentOrganization.id}
                    folderId={folderId}
                    onCancel={() => goBack()}
                    onDone={() => goBack()}
                />
            </ReactsCard>
        </div>
    )
};
